<template>
  <div>
    <!-- Barra de ferramentas - visível apenas na tela, oculta na impressão -->
    <div
      v-if="pdfUrl"
      class="toolbar"
    >
      <button
        class="btn-toolbar btn-imprimir"
        @click="imprimirProposta"
      >
        Imprimir
      </button>
    </div>

    <!-- Exibe o PDF retornado pelo backend -->
    <div
      v-if="pdfUrl"
      id="relatorio"
      style="width:100%; margin-top:60px;"
    >
      <iframe
        :src="pdfUrl"
        style="width:100%; height:100vh; border:0;"
        frameborder="0"
      />
    </div>
  </div>
</template>

<style>
body {
  background-color: #464646 !important;
}

/* Barra de ferramentas - visível apenas na tela */
.toolbar {
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 1000;
  display: flex;
  gap: 10px;
  background-color: rgba(255, 255, 255, 0.95);
  padding: 10px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.btn-toolbar {
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 5px;
}

.btn-imprimir {
  background-color: #4CAF50;
  color: white;
}

.btn-imprimir:hover {
  background-color: #45a049;
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

#relatorio {
  color: #363636;
  min-height: 90%;
  /* Ensure a minimum printed/page size of A4 regardless of content */
  min-width: 210mm;
  min-height: 297mm;
  box-sizing: border-box;
  width: 1100px;
  margin: auto;
  padding: 20px;
  z-index: -1;
  background-color: #fff;
  transform: scale(0.95);
}

.tarja-cinza {
  -webkit-print-color-adjust: exact;
  print-color-adjust: exact;
  background: repeating-linear-gradient(45deg,
      #cecece 20%,
      #ffffff 20%,
      #ffffff 43%,
      #cecece 43%,
      #cecece 55%,
      #ffffff 55%,
      #ffffff 90%) !important;
}

.containerbackground {
  left: -100px;
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
  position: absolute;
  top: 490px;
  bottom: 0px;
  color: #363636;
  font-size: 89px;
  opacity: 0.5;
  text-align: center;
}

.colunas {
  border-top: 1px solid #3c3c3c6b;
  border-right: 1px solid #3c3c3c6b;
}

.alinhar-empresa {
  margin-left: 89px;
}

/* Ocultar toolbar na impressão */
@media print {
  .toolbar {
    display: none !important;
  }

  body {
    background-color: white !important;
  }

  #relatorio {
    transform: scale(1) !important;
    margin: 0 !important;
    padding: 0 !important;
  }
}
</style>

<script>
import api from '@/app-modulo/comercial/cadastro-proposta/shared/services/api'
import apiExterna from '@/app-modulo/comercial/portal-proposta/shared/services/api'

export default {
  name: 'RelatorioProposta',
  data() {
    return { pdfUrl: null }
  },
  async created() {
    await this.carregar()
  },
  beforeDestroy() {
    if (this.pdfUrl && this.pdfUrl.startsWith('blob:')) {
      URL.revokeObjectURL(this.pdfUrl)
      this.pdfUrl = null
    }
  },
  methods: {
    async carregar() {
      const token = this.$route.query.token || null
      const service = (this.$route.params.externa === true || this.$route.params.externa === 'true')
        ? apiExterna
        : api

      try {
        const response = await service.getRelatorioProposta(this.$route.params.id, token)
        // Expecting ArrayBuffer (PDF bytes)
        const arrayBuffer = response?.data
        if (!arrayBuffer || (arrayBuffer.byteLength === 0)) {
          this.$erro('Relatório vazio ou não encontrado')
          return
        }

        const blob = new Blob([arrayBuffer], { type: 'application/pdf' })
        if (this.pdfUrl && this.pdfUrl.startsWith('blob:')) URL.revokeObjectURL(this.pdfUrl)
        this.pdfUrl = URL.createObjectURL(blob)
      } catch (err) {
        this.$erro(`Erro ao carregar relatório: ${err.response?.data?.message || err.message}`)
      }
    },
    imprimirProposta() {
      if (this.pdfUrl) {
        const w = window.open(this.pdfUrl)
        if (w) w.print()
      } else {
        window.print()
      }
    },
  },
}
</script>
